(function() { window.GUID_169dada4_36e5_4014_8284_aae0e484e74d = { getGuid: function() { return "169dada4-36e5-4014-8284-aae0e484e74d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatPeriod;
        (function (StatPeriod) {
            StatPeriod[StatPeriod["Season"] = 0] = "Season";
            StatPeriod[StatPeriod["Weekly"] = 1] = "Weekly";
        })(StatPeriod = Enumeration.StatPeriod || (Enumeration.StatPeriod = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatPeriod.pre.js.map
